export const links = [
  {
    href: "https://discord.gg/9sUDHyGQfC",
    name: "Discord",
    description: "FlyawayBear#7787",
    logo: <i className="fa-brands fa-discord fa-2x"></i>
  },
  {
    href: "https://github.com/flyawaybear",
    name: "GitHub",
    description: "FlyawayBear",
    logo: <i className="fa-brands fa-github fa-2x"></i>
  },
  {
    href: "https://www.youtube.com/channel/UCLoeX78R9HM5ogCteGACQqg",
    name: "YouTube",
    description: "Maybe subscribe?",
    logo: <i className="fa-brands fa-youtube fa-2x"></i>
  },
  {
    href: "https://twitch.tv/flyawaybear",
    name: "Twitch",
    description: "Maybe Follow??",
    logo: <i className="fa-brands fa-twitch fa-2x"></i>
  },
  {
    href: "https://discord.gg/9sUDHyGQfC",
    name: "Astroid Discord",
    description: "Maybe Join????",
    logo: <i className="fa-brands fa-discord fa-2x"></i>
  },
  {
    href: "https://vyper.group",
    name: "Vyper Group",
    description: "A game group site ig??",
    logo: <i className="fa-logos fa-web fa-2x"></i>
  },
  {
    href: "https://www.youtube.com/channel/UCgVM6Vv_uEto1D8blfwMdPg",
    name: "Vyper Group / Astroid Youtube",
    description: "Game site showcases and trailers",
    logo: <i className="fa-brands fa-youtube fa-2x"></i>
  },
];